var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import AntSpace from 'antd/lib/space';
export var StyledSpace = styled(AntSpace)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (_a) {
    var $fullWidth = _a.$fullWidth;
    return ($fullWidth ? '100%' : 'auto');
});
var templateObject_1;
//# sourceMappingURL=styled.js.map